import React, { useEffect } from "react";
import styles from "./custommodal.module.css";

const CustomModal = ({ isOpen, onRequestClose, children }) => {

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    return (
        <div className={`${styles["modal-overlay"]} ${isOpen ? styles["slide-in-right"] : styles["slide-out-right"]
            }`} onClick={onRequestClose}>
            <div
                className={`${styles["modal-content"]} ${isOpen ? styles["slide-in-right"] : styles["slide-out-right"]
                    }`}
                onClick={(e) => e.stopPropagation()} // Prevent clicks inside the modal from closing it
            >
                {children}
            </div>
        </div>
    );
};

export default CustomModal;
